export default "__VITE_ASSET__4h$zE91o__"